export default function useEarnings(totalData) {
  const netEarning = totalData?.stb_fee - (totalData?.discount + totalData?.cashback);
  const isProfitLoss = Math.sign(netEarning);

  return { netEarning, isProfitLoss };
}
